import { render } from "./ReadingStats.vue?vue&type=template&id=22911e4a&scoped=true"
import script from "./ReadingStats.vue?vue&type=script&lang=js"
export * from "./ReadingStats.vue?vue&type=script&lang=js"

import "./ReadingStats.vue?vue&type=style&index=0&id=22911e4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22911e4a"]])

export default __exports__